import React from 'react';

export const YearPicker = ({ value, onChange, start, end, name }) => {
	const years = [];
	for (let i = start; i <= end; i++) {
		years.push(i);
	}

	return (
		<select
			name={name}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', marginRight: '8px' }}
		>
			<option value="">Year</option>
			{years.map(year => (
				<option key={year} value={year}>{year}</option>
			))}
		</select>
	);
};

export const MonthPicker = ({ value, onChange, short, caps, endYearGiven, name }) => {
	const months = caps
		? ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER']
		: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

	return (
		<select
			name={name}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', marginRight: '8px' }}
		>
			<option value="">Month</option>
			{months.map((month, index) => (
				<option key={index + 1} value={index + 1}>{month}</option>
			))}
		</select>
	);
};

export const DayPicker = ({ value, onChange, name }) => {
	const days = [];
	for (let i = 1; i <= 31; i++) {
		days.push(i);
	}

	return (
		<select
			name={name}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
		>
			<option value="">Day</option>
			{days.map(day => (
				<option key={day} value={day}>{day}</option>
			))}
		</select>
	);
};
